// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('cohort' in value)) {
				errors.push({ path: 'value["cohort"]', expected: '"assigned-work" | "active-team-project"', value: undefined });
			} else {
				
    {
        let value__cohort___valid = false;
        
        if (!value__cohort___valid) {
            const value__cohort___errors_0 = [];
            if (value["cohort"] !== "assigned-work") value__cohort___errors_0.push({ path: 'value["cohort"]', expected: "assigned-work", value: value["cohort"] });
            if (value__cohort___errors_0.length === 0) {
                value__cohort___valid = true;
            }
        }

        if (!value__cohort___valid) {
            const value__cohort___errors_1 = [];
            if (value["cohort"] !== "active-team-project") value__cohort___errors_1.push({ path: 'value["cohort"]', expected: "active-team-project", value: value["cohort"] });
            if (value__cohort___errors_1.length === 0) {
                value__cohort___valid = true;
            }
        }
        if (!value__cohort___valid) {
            errors.push({ path: 'value["cohort"]', expected: '"assigned-work" | "active-team-project"', value: value["cohort"] });
        }
    }
			}
			if (!('jiraUrl' in value)) {
				errors.push({ path: 'value["jiraUrl"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["jiraUrl"] !== 'string') errors.push({ path: 'value["jiraUrl"]', expected: 'string', value: value["jiraUrl"] });
			}
			if (!('eligibleAsOf' in value)) {
				errors.push({ path: 'value["eligibleAsOf"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["eligibleAsOf"] !== 'string') errors.push({ path: 'value["eligibleAsOf"]', expected: 'string', value: value["eligibleAsOf"] });
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
